module.exports = __webpack_public_path__ + "img/howtomega.c2ef80f6.jpg";